import { i as isTabInput } from './keyboard.utils-b83395f0.js';

const focusableElements = [
  "A",
  "BUTTON",
  "INPUT",
  "TEXTAREA",
  "SELECT",
  "DETAILS",
];
const getElementIsNessieCheck = (element) => {
  var _a;
  if (element === null || element === void 0 ? void 0 : element.tagName.includes("NES")) {
    /* if element is nessie component focus the first focused
         element inside the shadowroot to show focus state */
    return (_a = element === null || element === void 0 ? void 0 : element.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll(focusableElements.toString().toLowerCase())[0];
  }
  else {
    return element;
  }
};
const focusTrap = (event, hostElement, wrapper, closeButton, foldButton) => {
  var _a, _b, _c;
  let focusableContent = [
    ...Array.from(hostElement.querySelectorAll("*")).filter((element) => {
      var _a;
      if (element === null || element === void 0 ? void 0 : element.tagName.includes("NES")) {
        return Boolean((_a = element === null || element === void 0 ? void 0 : element.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll(focusableElements.toString().toLowerCase())[0]);
      }
      else {
        return focusableElements.includes(element.tagName);
      }
    }),
  ];
  if (closeButton) {
    focusableContent.unshift(closeButton); // unshift to fix tab focus otherwise the focus go outside the side drawer
  }
  if (foldButton) {
    focusableContent.push(foldButton);
  }
  const firstFocusableElement = focusableContent[0]; // get first element to be focused inside dialog
  let lastFocusableElement;
  if (focusableContent && !!focusableContent.length) {
    lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside dialog
  }
  if (isTabInput(event.key)) {
    if (event.shiftKey) {
      // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement ||
        ((_a = hostElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.activeElement) === firstFocusableElement ||
        ((_b = hostElement.shadowRoot) === null || _b === void 0 ? void 0 : _b.activeElement) === wrapper) {
        // if focused has reached to first focusable element then focus last focusable element after pressing shift tab
        getElementIsNessieCheck(lastFocusableElement).focus(); // add focus for the last focusable element
        event.preventDefault();
      }
    }
    else {
      // if tab key is pressed
      if (document.activeElement === lastFocusableElement ||
        ((_c = hostElement.shadowRoot) === null || _c === void 0 ? void 0 : _c.activeElement) === lastFocusableElement) {
        // if focused has reached to last focusable element then focus first focusable element after pressing tab
        getElementIsNessieCheck(firstFocusableElement).focus(); // add focus for the last focusable element
        event.preventDefault();
      }
    }
  }
};

export { focusTrap as f, getElementIsNessieCheck as g };
